/* eslint-disable no-redeclare */
import { z } from 'zod';

export const BtSid = z.string();

export type BtSid = z.infer<typeof BtSid>;
